const breadcrumbMap = {

    
    '/dashboard': ['Home', 'Dashboard'],

    //Finance Role
    '/all-invoices':                            ['Home', 'Influencer Invoices', 'All Invoices'],
    '/pending-invoices':                        ['Home', 'Influencer Invoices', 'Pending Invoices'],
    '/completed-invoices':                      ['Home', 'Influencer Invoices', 'Completed Invoices'],
    '/cencelled-invoices':                      ['Home', 'Influencer Invoices', 'Cancelled Invoices'],

    // DM TL & DM EXE
    '/active-influencer':                       ['Home', 'Influencer', 'Active Influencer'],
    '/assigned-influencer':                     ['Home', 'Influencer', 'Assigned Influencer'],
    '/pending-influencer':                      ['Home', 'Influencer', 'Pending Influencer'],
    '/inactive-influencer':                     ['Home', 'Influencer', 'Inactive Influencer'],
    '/all-influencer':                          ['Home', 'Influencer', 'All Influencer'],

    '/client-request-in-dm':                    ['Home', 'Request', 'All Client Request'],
    '/suggested-influencer':                    ['Home', 'Sub Request', 'Influencer Sub Request'],

    '/client-sub-request-in-dm-tl':             ['Home', 'Suggested Influencer', 'Suggested Influencer'],
    '/approved-client-sub-request-in-dm-tl':    ['Home', 'Suggested Influencer', 'Approved Influencer'],
    '/rejected-client-sub-request-in-dm-tl':    ['Home', 'Suggested Influencer', 'Rejected Influencer'],

    '/upcoming-videos':                         ['Home', 'Videos', 'Upcoming Videos'],
    '/post-videos':                             ['Home', 'Videos', 'Past Videos'],
    '/all-videos':                              ['Home', 'Videos', 'All Videos'],

    '/influencer-access-request-in-dm-tl':      ['Home', 'Access Request', 'Influencer Access'],

    '/all-invoices':                            ['Home', 'Influencer Invoices', 'All Invoices'],

    // Sales TL & Sales EXE
    '/all-clients':                             ['Home', 'Clients', 'All Clients'],
    '/inactive-clients':                        ['Home', 'Clients', 'Inactive Clients'],
    '/pending-clients':                         ['Home', 'Clients', 'Pending Clients'],
    '/assigned-clients':                        ['Home', 'Clients', 'Assigned Clients'],
    '/active-clients':                          ['Home', 'Clients', 'Active Clients'],

    '/client-request-in-sales':                 ['Home', 'Client Request', 'Client Request List'],

    '/suggested-influencer-list':               ['Home', 'Influencer', 'Suggested Influencer List'],
    '/approved-suggested-influencer-list':      ['Home', 'Influencer', 'Approved Influencer List'],
    '/rejected-suggested-influencer-list':      ['Home', 'Influencer', 'Rejected Influencer List'],


    // Client
    '/client-all-request':                      ['Home', 'Request', 'Influencer Request List'],

    '/suggested-influencer-by-sales':           ['Home', 'Influencer', 'Suggested Influencer List'],
    '/approved-suggested-influencer-by-sales':  ['Home', 'Influencer', 'Approved Influencer List'],
    '/rejected-suggested-influencer-by-sales':  ['Home', 'Influencer', 'Rejected Influencer List'],

    '/influencer-discover':  ['Home', 'discover', 'Influencer Discover'],
    '/influencer-insights':  ['Home', 'insights', 'Influencer Insights'],
    '/exports-list':  ['Home', 'exports', 'exports'],


};

export default breadcrumbMap;
